import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import React from "react";

const AppointmentCalender = ({handleDateClick})=>{
    return(
        <React.Fragment>
            <div className="h-50">
                <FullCalendar
                    plugins={[
                        dayGridPlugin,
                        interactionPlugin,
                    ]}
                    initialView="dayGridMonth"
                    // slotDuration={"00:15:00"}
                    handleWindowResize={true}
                    headerToolbar={{
                        left: "prev,next",
                        center: "title",
                    }}
                    selectable={true}
                    dateClick={handleDateClick}
                />
            </div>
        </React.Fragment>
    )
}

export default AppointmentCalender;